import { ClientTelephone } from './client-telephone';

export class ClientModel {
    public id: string;
    public name1: string;
    public name2: string;
    public email: string;
    public telephone: ClientTelephone;
    public password: string;
    public document1: string;
    public document2: string;
    public social_uid: string;
    public social_network: string;
    public legal_personality: number;
    public extra_fields: object = {};
    public shareable_key: string;
}



// WEBPACK FOOTER //
// /codebuild/output/src727013012/src/src/app/shared/models/client.model.ts